import ja from "../langs/ja.json5";
import en from "../langs/en.json5";
import de from "../langs/de.json5";
import it from "../langs/it.json5";
import es from "../langs/es.json5";
import zh_TW from "../langs/zh-TW.json5";
import id from "../langs/id.json5";
import sv from "../langs/sv.json5";
import hu from "../langs/hu.json5";
import la from "../langs/la.json5";
import tr from "../langs/tr.json5";
import lt from "../langs/lt.json5";
import fr from "../langs/fr.json5";

export default
{
    ja: { common: ja },
    en: { common: en },
    de: { common: de },
    it: { common: it },
    es: { common: es },
    'zh-TW': { common: zh_TW },
    id: { common: id },
    sv: { common: sv },
    hu: { common: hu },
    la: { common: la },
    tr: { common: tr },
    lt: { common: lt },
    fr: { common: fr },
}
